import moment from "moment";

export interface IClassDetails { 
    name: string;
    time: string;
    notes?: string;
}

export interface IDaySchedule {
    days: string[];
    classes: IClassDetails[];
}

const schedule: IDaySchedule[] = [
    {
        days: ['Monday', 'Wednesday'],
        classes: [
            { name: 'Open Mat', time: '5:00 AM' },
            { name: 'Adult Gi BJJ', time: '12:00 PM' },
            { name: 'Gi Open Mat', time: '1:00 PM' },
            { name: 'Kids BJJ', time: '5:00 PM', notes: 'Monday No Gi, Wednesday Gi' },
            { name: 'Muay Thai', time: '5:15 PM' },
            { name: 'BJJ Fundamentals', time: '5:15 PM' },
            { name: 'Adult Gi BJJ', time: '6:15 PM' },
            { name: "Women's Only Class", time: '6:15 PM' },
            { name: "Women's Only Open Mat", time: '7:00 PM' },
            { name: 'Gi Open Mat', time: '7:00 PM' },
        ],
    },
    {
        days: ['Tuesday'],
        classes: [
            { name: 'Open Mat', time: '5:00 AM' },
            { name: 'Gi Drilling', time: '6:00 AM' },
            { name: 'Adult No Gi BJJ', time: '12:00 PM' },
            { name: 'No Gi Open Mat', time: '1:00 PM' },
            { name: 'Kids No Gi BJJ', time: '5:00 PM'},
            { name: 'BJJ Fundamentals', time: '5:15 PM' },
            { name: 'Wrestling', time: '5:15 PM' },
            { name: 'Muay Thai', time: '5:30 PM' },
            { name: 'Adult No Gi BJJ', time: '6:15 PM' },
            { name: 'No Gi Open Mat', time: '7:00 PM' },
        ],
    },
    {
        days: ['Thursday'],
        classes: [
            { name: 'Cross Training Open Mat', time: '12:00 PM' },
            { name: 'Kids Gi BJJ', time: '5:00 PM', },
            { name: 'Muay Thai', time: '5:15 PM' },
            { name: 'Wrestling', time: '5:15 PM' },
            { name: 'BJJ Fundamentals', time: '5:15 PM' },
            { name: 'Adult Gi BJJ', time: '6:15 PM' },
            { name: 'Gi Open Mat', time: '7:00 PM' },
        ],
    },
    {
        days: ['Friday'],
        classes: [
            { name: 'Open Mat', time: '5:00 AM' },
            { name: 'Adult No Gi BJJ', time: '12:00 PM' },
            { name: 'No Gi Open Mat', time: '1:00 PM' },
        ],
    },
    {
        days: ['Saturday'],
        classes:  [
            { name: 'Gi Comp Training', time: '10:00 AM' },
        ],
    }
];

export default class ClassesService {
    getTodaysSchedule(): IDaySchedule | undefined {
        const today = moment().format('dddd');
        return schedule.find(x => x.days.indexOf(today) >= 0);
    }

    getNextClass(currentTime: Date): Date {
        let currentMoment = moment(currentTime);
        let nextClassTime: Date | undefined;

        while (!nextClassTime) {
            let today = currentMoment.format('dddd');
            const currentSchedule = this._getClassesForDay(today);

            if (currentSchedule) {
                nextClassTime = this._getNextClassTime(currentTime, currentMoment.toDate(), currentSchedule);
            }

            if (!nextClassTime) {
                currentMoment.add(1, 'd');
            }
        }

        return nextClassTime;
    }

    getSchedule(): IDaySchedule[] {
        return schedule;
    }

    _getClassesForDay(dayName: string): IDaySchedule | undefined {
        return schedule.find(x => x.days.indexOf(dayName) >= 0);
    }

    _getNextClassTime(currentTime: Date, day: Date, daySchedule: IDaySchedule): Date | undefined {
        const currentMoment = moment(currentTime);
        let nextClassTime: moment.Moment | undefined;
        daySchedule.classes.forEach(classSchedule => {
            const classTime = moment(`${moment(day).format('MM-DD-YYYY')} ${classSchedule.time}`, 'MM-DD-YYYY h:mm AA');
            if (classTime > currentMoment && (!nextClassTime || classTime < nextClassTime)) {
                nextClassTime = classTime; 
            }
        });

        return nextClassTime ? nextClassTime.toDate() : undefined;
    }
}